export enum InvitationCampaign {
    Special_GP = 'SPECIAL_GP',
    THT_PLUS = 'THT_PLUS'
}